"use client";
import { jsxs as n, jsx as a } from "react/jsx-runtime";
const c = ({
  title: l,
  titleId: i,
  desc: r,
  descId: e,
  ...h
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": e,
    ...h,
    children: [
      r ? /* @__PURE__ */ a("desc", { id: e, children: r }) : null,
      l ? /* @__PURE__ */ a("title", { id: i, children: l }) : null,
      /* @__PURE__ */ a("path", { d: "M23 21V11a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1m-8-9h2v2.382l-.553-.276a1 1 0 0 0-.895 0l-.552.276zm6 8H11v-8h2v4a1.001 1.001 0 0 0 1.448.895L16 16.118l1.553.776A1.001 1.001 0 0 0 19 16v-4h2zM3 16C3 9.803 7.362 4.613 13.175 3.318l-.729-.486a1 1 0 1 1 1.11-1.664l3 2a1 1 0 0 1 .277 1.387l-2 3a1 1 0 1 1-1.664-1.11l.837-1.255C8.89 6.133 5 10.617 5 16c0 4.657 2.946 8.823 7.332 10.366a1 1 0 1 1-.664 1.886C6.483 26.429 3 21.505 3 16M19.057 4.358a1 1 0 0 1 1.275-.611C25.517 5.57 29 10.496 29 16c0 6.197-4.362 11.387-10.175 12.682l.729.486a1 1 0 1 1-1.11 1.664l-3-2a1 1 0 0 1-.277-1.387l2-3a1 1 0 1 1 1.664 1.11l-.837 1.255C23.11 25.867 27 21.383 27 16c0-4.657-2.946-8.823-7.332-10.367a.999.999 0 0 1-.611-1.275" })
    ]
  }
);
export {
  c as default
};
